// extracted by mini-css-extract-plugin
export var icon = "breadcrumb-module--icon--98e07";
export var mainWrapper = "breadcrumb-module--mainWrapper--5a9ec";